import React from 'react'
import './styles.css'

export default function PageNotFound() {
  return (
    <div className='PNF'>
      <h3>404 Page Not Found</h3>
      <p>The page you are looking for does not exist.</p>
    </div>
  )
}
